import React, { useMemo, useState } from 'react'

import { responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles'
import { cookies as zxAuthCookies } from '@xti-external/frontend-kit-auth/auth'

import { currentDomain, currentSubdomain } from '~/config'
import { LOCAL_STORAGE_KEY_USER, orgCodeLoginMapping } from '~/config/constants'
import { createDynamicTheme } from '~/styles/theme'
import * as Storage from '~/utils/localStorage'

interface AuthContextProps {
  isKalista: boolean
  isLoggedIn: boolean
  permissions: any
  userData: any
  setIsLoggedIn: (isLoggin: boolean) => void
  setPermissions: (permissions: any) => void
  setUserData: (userData: any) => void
}

export const AuthContext = React.createContext<Partial<AuthContextProps>>({})

interface AuthProviderProps {
  children: React.ReactNode
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    Boolean(zxAuthCookies.getToken()?.token)
  )
  const [userData, setUserData] = useState(Storage.load(LOCAL_STORAGE_KEY_USER))
  const [permissions, setPermissions] = useState([])

  const orgCode = useMemo(
    () =>
      userData?.userOrg?.parentOrgCode?.toLowerCase() ||
      userData?.userOrg?.orgCode?.toLowerCase() ||
      orgCodeLoginMapping[currentSubdomain] ||
      orgCodeLoginMapping[currentDomain] ||
      'fleeto',
    [userData]
  )

  const isKalista = useMemo(() => orgCode === 'kalista', [orgCode])

  const theme = useMemo(
    () => responsiveFontSizes(createDynamicTheme(orgCode)),
    [orgCode]
  )

  return (
    <AuthContext.Provider
      value={{
        isKalista,
        isLoggedIn,
        setIsLoggedIn,
        userData,
        setUserData,
        setPermissions,
        permissions,
      }}
    >
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </AuthContext.Provider>
  )
}
